export { default as Input } from './Input.vue'

// Field-chrome NOTE (picker-trio decision, 2026-07-20; radius REVISED
// 2026-07-22): input, select trigger, native-select and the combobox field
// carry the SAME closed field chrome — border-input · h-9 · rounded-md (8px,
// the stock shadcn field radius — NOT the button pill; "always pills" is the
// BUTTON grammar only) · shadow-xs — deliberately as per-component copies
// (shadcn copy-paste independence; a shared fieldChromeClass extraction was
// tried and REVERTED same day). If the field chrome ever changes, change all
// four recipes together.

// Field affix — the toolkit's lime CIRCULAR icon-affix (design review
// 2026-07-19; Ratify v2 FLD 2026-07-20 made it the pick-field DEFAULT). It
// stays `rounded-full` because it is a round icon BADGE inside the field, not
// the field corner (the field itself is rounded-md). ONE definition so every
// field surface shares the ruleset: combobox leads with it, the date-picker
// composition and the form IconAffix story compose it. Sized for the h-9 field
// (size-7 circle, field uses ps-1); override size via cn when composing taller
// fields.
export const inputAffixClass
  = 'bg-secondary text-secondary-foreground pointer-events-none flex size-7 shrink-0 items-center justify-center rounded-full [&_svg]:size-3.5'
